import Modal from '../../../../shared/Modal'
import { useCallback, useState } from 'react'
import useTableWithRequest from '../../../../shared/Table/ctrl/useTableWithRequest'
import promosApi from '../../promos.api'
import { IUser } from '../../../AuthProvider/user.api'
import usersTableFields from './usersTable.fields'
import Table from '../../../../shared/Table'
import TextInput from '../../../../shared/Inputs/TextInput'
import Button from '../../../../shared/Buttons/Button'
import css from './grantUser.module.css'
import cn from '../../../../shared/cn'
import { IPlan } from '../../promos.types'
import PlanSelect from '../PlanSelect'
import useHttpLoader from '../../../../hooks/useHttpLoader'
import useDebounce from '../../../../shared/hooks/useDebounce'

interface IProps {
  onClose: () => void
}

const GrantUserSubscriptionModal = (props: IProps) => {
  const { wait, loading } = useHttpLoader()

  const [items, setItems] = useState<IUser[]>([])
  const [selectedUser, setSelectedUser] = useState<IUser | null>(null)
  const [search, setSearch] = useState<string>('')
  const dSearch = useDebounce(search, 500)

  const [isGranted, setIsGranted] = useState<boolean>(false)
  const [selectedPlan, setSelectedPlan] = useState<IPlan['id']>(null)

  const loadData = useCallback(
    (params: any) => {
      return promosApi.getUsers({ ...params, search })
    },
    [dSearch]
  )

  const tableCtrl = useTableWithRequest<IUser>({
    storageType: 'inMemory',
    dataFetcher: loadData,
    fields: usersTableFields,
    items,
    setItems,
    itemKey: 'id',
    tableKey: 'plan',
  })

  const handleGrantSubscription = () => {
    wait(promosApi.grantSubscription({ user: selectedUser.id, plan: selectedPlan }), (resp) => {
      if (resp.status === 'success') {
        setIsGranted(true)
      }
    })
  }

  const renderContent = () => {
    if (!isGranted) {
      return (
        <div className={cn('flex-form', css.wrapper)}>
          <h2 className="form-header" style={{ textAlign: 'center', fontFamily: 'Chitalka' }}>
            Выберите пользователя
          </h2>
          <div className="flex-form" style={{ gap: 0 }}>
            <TextInput value={search} name="search" onChange={setSearch} placeHolder="Поиск по email" />
            <div style={{ height: '300px', background: '#fff', padding: '10px 5px' }}>
              <Table
                fields={tableCtrl.fields}
                loading={tableCtrl.loading}
                items={tableCtrl.orderedItems}
                itemKey="id"
                totalItemsCount={tableCtrl.totalItemsCount}
                pageNumber={tableCtrl.pageNumber}
                itemsPerPage={tableCtrl.itemsPerPage}
                orderingState={tableCtrl.orderingState}
                onOrderingStateChange={tableCtrl.onOrderingStateChange}
                onSwap={tableCtrl.onSwap}
                resizePluginCtrl={tableCtrl.resizePluginCtrl}
                onClick={setSelectedUser as any}
              />
            </div>
          </div>
          {selectedUser && (
            <>
              <p>
                Подтвердите выдачу подписки (премиум-доступа) пользователю{' '}
                <span style={{ fontWeight: 'bold' }}>{selectedUser.email}</span> и выберите план (ВИП или
                Премиум-доступ)
              </p>
              <PlanSelect plan={selectedPlan} name="selectedPlan" onChange={setSelectedPlan} autoSelect="ONE_TIME" />
              <Button onClick={handleGrantSubscription} disabled={!selectedPlan} loading={loading}>
                Подтвердить
              </Button>
            </>
          )}
        </div>
      )
    }

    return (
      <div className={css.wrapper}>
        <h2 className="form-header" style={{ textAlign: 'center', fontFamily: 'Chitalka' }}>
          Подписка успешно выдана пользователю {selectedUser.email}
        </h2>
        <Button onClick={props.onClose}>Закрыть</Button>
      </div>
    )
  }

  return (
    <Modal onClose={props.onClose} size="lg">
      {renderContent()}
    </Modal>
  )
}

export default GrantUserSubscriptionModal
